<template>
  <div class="Action-form Action-form--group">
    <div class="Action-form__input Action-form__input--workpsychologypolicy">
      <div v-if="isPositive" class="Action-form__input__inputs">
        <UploadInput
          :fileName="action.attachmentFileName"
          :fileUrl="action.attachmentUrl"
          :allowed-file-types="['pdf']"
          :max-file-size="50000000"
          @touch="resizeExpander"
          @input="handleChangeFile"
          @remove="handleRemoveFile"
          @download="onFileDownload"
          :downloading="downloadIsLoading"
          :disabled="isDisabled"
        />
        <p class="Action-form__info" v-if="action.attachmentUrl">
          <em>En fil har laddats upp</em>
        </p>
      </div>
      <div v-if="!isApplicant" class="Action-form__controls">
        <ToggleInput
          :value="approved"
          :disabled="!action.isValid || !isDisabled"
          text="Godkänt krav"
          @input="handleChangeApproved"
        />
        <div v-if="!approved">
          <button
            v-if="submitted"
            class="Button Button--secondary"
            @click="unlockAction"
          >
            Lås upp för komplettering
          </button>
          <button v-else class="Button Button--primary" @click="lockAction">
            Avsluta komplettering
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import UploadInput from "@/components/forms/UploadInput";
import ToggleInput from "@/components/forms/ToggleInput";
import { saveAs } from "file-saver";
import { required } from "vuelidate/lib/validators";
import { EventBus } from "@/services/event-bus";

export default {
  name: "ApplicationActionMetaWorkpsychologyPolicy",
  components: { UploadInput, ToggleInput },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isPositive: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      downloadIsLoading: false
    };
  },
  validations: {
    action: {
      group: {
        companyName: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    ...mapState("applicationStore", ["application"]),
    approved() {
      return this.action.status === "APPROVED";
    },
    submitted() {
      return this.action.status === "IN_REVIEW";
    },
    isDisabled() {
      return this.submitted || this.approved;
    }
  },
  watch: {
    "$v.$anyError": function() {
      EventBus.$emit("expander:resize");
    }
  },
  methods: {
    ...mapActions("applicationStore", [
      "approveAction",
      "updateWorkpsychologyPolicy",
      "submitAction",
      "uploadAttachment",
      "removeAttachment",
      "getFileForAction"
    ]),
    handleChangeFile(files) {
      if (files && files.length && files[0] && !this.disabled) {
        this.uploadAttachment({
          actionId: this.action.id,
          file: files[0]
        });
      }
    },
    resizeExpander() {
      EventBus.$emit("expander:resize");
    },
    handleRemoveFile() {
      this.removeAttachment({
        actionId: this.action.id
      });
    },
    handleChangeApproved(isChecked) {
      this.approveAction({
        actionId: this.action.id,
        approved: isChecked
      });
    },
    unlockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: false
      });
    },
    lockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: true
      });
    },
    onFileDownload(fileName) {
      if (!this.downloadIsLoading) {
        this.downloadIsLoading = true;
        this.getFileForAction({
          actionId: this.action.id
        }).then(response => {
          this.downloadIsLoading = false;
          let blob = new Blob([response], { type: "application/pdf" });
          saveAs(blob, `${fileName}`);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Action-form__input__inputs {
  flex-direction: column;
  align-items: normal;
}
</style>
